import { Injectable } from '@angular/core';
import { HttpService } from '../../core/http/http.service';
import { LayoutUrls } from '../constants/layout.constants';
import { CustomerAccount } from '../models/customer-account.interface';
import { LayoutService } from '../state/layout.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LayoutHttpService {

  constructor(private http: HttpService, private layoutService: LayoutService) { }

  getCustomerAccounts() {
    return this.http.get<CustomerAccount[]>(LayoutUrls.CustomerAccounts)
                    .pipe(tap( (customerAccounts: CustomerAccount[]) => this.layoutService
                    .updateLayout({customerAccounts, customerAccount: customerAccounts.find(acc => acc.isDefault)})));
  }
}
